export default {
  'component.globalHeader.search': '검색',
  'component.globalHeader.search.example1': '검색 예시 1',
  'component.globalHeader.search.example2': '검색 예시 2',
  'component.globalHeader.search.example3': '검색 예시 3',
  'component.globalHeader.help': '도움말',
  'component.globalHeader.notification': '알림',
  'component.globalHeader.notification.empty':
    '모든 알림을 확인했습니다.',
  'component.globalHeader.message': '메시지',
  'component.globalHeader.message.empty': '모든 메시지를 확인했습니다.',
  'component.globalHeader.event': '이벤트',
  'component.globalHeader.event.empty': '모든 이벤트를 확인했습니다.',
  'component.noticeIcon.clear': '지우기',
  'component.noticeIcon.cleared': '지워짐',
  'component.noticeIcon.empty': '알림 없음',
  'component.noticeIcon.view-more': '더보기',
};
